import React, { useEffect, useState } from 'react';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import BsModal from '../../Common/BsModal';
import TextInput from '../../Common/TextInput';

const EditPaperModal = () => {
  const [paperName, setPaperName] = useState('');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState(null);
  const {editPaper, setEditPaper} = useConfig();

  useEffect(() => {
    if (editPaper.paper) {
      setPaperName(editPaper.paper.paper_code || '');
    }
  }
  , [editPaper.paper]);

  const handleSave = async () => {
    if (paperName.length === 0) {
      setNotify(<Notification type='danger' message='Paper name is required' />);
      return;
    }

    setLoading(true);
    const server_response = await ajaxConfig.updateSubjectPaper(editPaper.paper.paper_id, paperName);
    setLoading(false);
    if (server_response.status === "OK") {
      editPaper.callback();
      setNotify(<Notification type='success' message={server_response.message} />);
    } else {
      setNotify(<Notification type='danger' message={server_response.message} />);
    }
  };

  const closeModal = () => {
    setNotify(null);
    setEditPaper({ show: false, paper: null });
  };


  return (
    <BsModal
      show={editPaper.show}
      onClose={closeModal}
      title={`Edit Subject Paper - ${editPaper.paper?.paper_code || ''}`}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            disabled={loading || !paperName}
            onClick={handleSave}
          >
            <i className="fa fa-plus-circle mr-1"></i> Save Changes
          </button>
        </>
      }
    >
      <TextInput
        label="Paper Name"
        placeholder="Enter Paper Name"
        leftIcon="fa fa-book"
        value={paperName}
        onChange={e => setPaperName(e.target.value)}
        required
      />
     

      {loading && <div className="mt-3"><i className="fa fa-spinner fa-spin"></i> Saving...</div>}
      {notify}
    </BsModal>
  );
};

export default EditPaperModal;
